export const RegularExp = {
  PHONE:
    /(^(?!\+.*\(.*\).*\-\-.*$)(?!\+.*\(.*\).*\-$)([+0-9]{1}[0-9]{1}[(0-9]{2}[()0-9]{1}[0-9]{1}([)0-9]{0,1})?([0-9]{0,1})?([)-0-9]{0,1})?([-0-9]{0,7})?([0-9]{0,3})?)$)|(^[0-9]{1,4}$)/,
  EMAIL: /\S+\@\S+\.[a-z]+/i,
  PIN: /^([0-9]{4})$/,
};

export const CodeFormType = {
  EMAIL: `email`,
  PHONE: `phone`,
};
